/**
 * Javascript for the CMS
 */
import tableRowLink from "../../javascript/table-row-link.js";
import {select} from "./select-checkboxes.js";
import del from "./delete-confirmation.js";
import tabs from "./tabs-menu.js";
import popup from "./function-popup.js";
import toolbar from "./toolbar.js";

import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/manipulation/insertto/insertto.js";

export default obj => {
	if (obj.length) {

		// set table row links
		tableRowLink($(".cms-list__table", obj));

		// add a checkbox to control checking/unchecking all checkboxes in the CMS list view
		select($(".cms-list__header-invert", obj), $(".cms-list__select-checkbox", obj));

		// delete confirmation
		del(obj);

		// export field selection
		const id = "cms-export-invert",
			label = $("<label>", {for: id, "class": "cms-controls__export-popup-invert", text: "Select All/None"});
		select(label, $("input[name='export[]']"), id).insertAfter("#cms-export ~ .cms-controls__export-popup h2");
	}

	// CMS popup functions
	popup($(".cms-controls__function-popup"));

	// close mobile tabs menu
	tabs($("#cms-tabs-switch"));

	// indicate the toolbar is floating
	toolbar($(".cms-controls:not(.cms-controls--transparent)"));
};
